import { Grid} from '@mui/material';

import './style.scss'

import EmployerBanner from '../login/employerBanner';
import JobSeekerBanner from '../login/jobSeekerBanner';
import CreatePasswordComponent from './createPasswordComponent';
// EMPLOYER LOGIN PASSWORD CREATE FUNCTION 
const CreatePasswordEmployerLogin = () => {

  const queryParams = new URLSearchParams(window.location.search);
  const rolesEmployee = queryParams.get('roles');


  return (
    <div className="SinginFormPage">
      <Grid container spacing={0}>
        <Grid item xs={12} sm={6} lg={6}>
          {rolesEmployee === 'employer' ? <EmployerBanner /> : <JobSeekerBanner />}
        </Grid>
        <Grid item xs={12} sm={6} lg={5}>
          <CreatePasswordComponent />
        </Grid>
      </Grid>
      <img src={require('../../assets/images/geo.png')} className="SignInGeoTop" alt="" />
      <img src={require('../../assets/images/geo1.png')} className="SignInGeoBottom" alt="" />
    </div>
  );
}

export default CreatePasswordEmployerLogin;